<template>
  <template>
    <Marker :options="options" @click="onClick">
      <InfoWindow ref="infoWindowRef" :options="infoWindowOptions" v-if="renderInfoWindow">
        <EcoEventsInfo :description="description" :data="data" />
      </InfoWindow>
    </Marker>
  </template>
</template>

<script>
import {InfoWindow, Marker} from "vue3-google-map";
import EcoEventsInfo from "@/components/pages/EcoEventsInfo.vue";
import {entityDataManager} from "@/assets/js/data-manipulation";
import hardCorneringIcon from "@/assets/images/reports/hard-cornering.png";
import hardBrakingIcon from "@/assets/images/reports/hard-braking.png";
import hardAccelerationIcon from "@/assets/images/reports/hard-acceleration.png";
import alarmBellIcon from "@/assets/images/reports/alarm-bell.png";

export default {
  name: "AlarmMarker",
  components: {EcoEventsInfo, Marker, InfoWindow},
  props: {
    data: {
      type: Object,
      required: true
    },
    positionData: {
      type: Object,
      required: true
    },
    openInfoOnClick: {
      type: Boolean,
      default: true
    },
    customOptions: Object,
  },
  emits: ['click'],
  data() {
    return {
      renderInfoWindow: false
    };
  },
  computed: {
    options() {
      return {
        ...{
          position: this.position,
          icon: this.markerIcon,
        },
        ...this.customOptions
      };
    },
    infoWindowOptions() {
      return {
        position: this.position,
        headerContent: this.data.headerContent,
      };
    },
    position() {
      return entityDataManager.getGoogleGeoByPosition(this.positionData);
    },
    description() {
      return entityDataManager.getTranslatedMessageByEvent('alarm', this.positionData['alarm']);
    },
    markerIcon() {
      switch (this.positionData['alarm']) {
        case 'hardCornering':
          return hardCorneringIcon;
        case 'hardBraking':
          return hardBrakingIcon;
        case 'hardAcceleration':
          return hardAccelerationIcon;
        default:
          return alarmBellIcon;
      }
    }
  },
  methods: {
    onClick() {
      this.$emit('click', this);
      if (this.openInfoOnClick) {
        this.showInfoWindow();
      }
    },
    showInfoWindow() {
      this.renderInfoWindow = true;
      setTimeout(() => this.$refs.infoWindowRef?.open(), 10);
    },
    closeInfoWindow() {
      this.$refs.infoWindowRef?.close();
      this.renderInfoWindow = false;
    },
    isInfoWindowOpen() {
      return this.$refs.infoWindowRef?.infoWindow.isOpen;
    }
  }
}
</script>

<style scoped lang="scss">

</style>